export default {
  namespaced: true,
  state: {
    fromTable: false,
  },
  getters: {
    fromTable: (state: any) => state.fromTable,
  },
  mutations: {
    SET_FROM_TABLE(state: any, payload: any) {
      state.fromTable = payload ?? false
    },
  },
}
